<template>
  <div class="dialog-container wt-dialog-container">
    <div>
      <div class="wt-tab-info-card">
        <div class="wt-tab-info-title">基本信息</div>
        <div class="wt-tab-info-content wt-tab-base">
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">账号：</span>
            <span class="wt-tab-base-value">{{ detailFormData.userName }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">姓名：</span>
            <span class="wt-tab-base-value">{{ detailFormData.name }}</span>
          </div>
          <div class="wt-tab-base-item">
            <span class="wt-tab-base-label">手机号：</span>
            <span class="wt-tab-base-value">{{ detailFormData.phone }}</span>
          </div>
        </div>
      </div>
      <div class="wt-tab-info-card">
        <div class="wt-tab-info-title">社区站点</div>
        <div class="wt-tab-info-content">
          <wt-form-table :form.sync="siteForm" @on-button-action="onButtonAction"></wt-form-table>
        </div>
      </div>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'UserAreaViewPage',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      siteForm: {
        hidePage: true,
        isFormLoading: false,
        formComponent: {
          view: { type: 'component', componentName: 'UserAreaSiteViewPage', value: 'queryUserMessageDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/userEmployees/userAreaManagerSiteList', params: {}}
        },
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '站点名称', key: 'name', type: 'text' },
          { name: '站长姓名-手机号', key: 'employeesName', type: 'text' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, searchButtonHidden: true }
      },
      detailFormButtons: {
        title: '区域负责人详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      }
    }
  },
  created() {
    this.siteForm.formComponent.list.params.id = this.detailFormData.id
  },
  methods: {
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    onButtonAction(data) {
      if (data && data.item) {
        this.$store.dispatch('setSiteDetailData', JSON.parse(JSON.stringify(data.row)))
      }
    }
  },
  computed: {
    ...mapState({
      detailFormData: state => state.userMaster.userMasterDetailData
    })
  }
}
</script>

<style scoped>
.action-check-group {
  padding-left: 180px;
}
.action-check-group .el-checkbox {
  margin-bottom: 8px;
}
</style>
